
import { Injectable } from '@angular/core';
import { FEATURE_ANNOUNCEMENTS, FeatureAnnouncement } from './feature-announcements';
import { BehaviorSubject } from 'rxjs';

const KEY_PREFIX = 'featureBellSeen:';

@Injectable({ providedIn: 'root' })
export class FeatureBellService {
  private seenSubjects = new Map<string, BehaviorSubject<boolean>>();

  private storageKey(id: string): string {
    return `${KEY_PREFIX}${id}`;
  }

  shouldShow(id: string): boolean {
    const config = FEATURE_ANNOUNCEMENTS.find(a => a.id === id);
    if (!config) return false;
    if (new Date() > config.cutoff) return false;
    return localStorage.getItem(this.storageKey(id)) !== '1';
  }

    private computeShouldShow(id: string): boolean {
        const config = FEATURE_ANNOUNCEMENTS.find(a => a.id === id);
        if (!config) return false;
        if (new Date() > config.cutoff) return false;
        return localStorage.getItem(this.storageKey(id)) !== '1';
    }

    /** Returns an observable that emits whenever this bell's visibility changes. */
    watch(id: string) {
        if (!this.seenSubjects.has(id)) {
            this.seenSubjects.set(id, new BehaviorSubject<boolean>(this.computeShouldShow(id)));
        }
        return this.seenSubjects.get(id)!.asObservable();
    }

    markSeen(id: string): void {
        localStorage.setItem(this.storageKey(id), '1');
        this.seenSubjects.get(id)?.next(false);
    }

    cleanupExpired(): void {
        const now = new Date();
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (!key?.startsWith(KEY_PREFIX)) continue;
            const id = key.substring(KEY_PREFIX.length);
            const config = FEATURE_ANNOUNCEMENTS.find(a => a.id === id);
            if (!config || now > config.cutoff) {
                localStorage.removeItem(key);
            }
        }
    }

}